module.exports = __webpack_public_path__ + "img/dep_candyandgum@3x.43f25699.png";